
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { I18nMixin } from '../../mixins';
import { IHomepageHomeServeExpertDefaultI18n, IHomepageHomeServeExpertOverrideI18n } from './types';
import WLHomeServeExpertBlock from './WLHomeServeExpertBlock.vue';
@Component({
  components: {
    WLHomeServeExpertBlock,
  },
})
export default class HomeServeExpert extends Mixins(I18nMixin) {
  public defaultI18n!: IHomepageHomeServeExpertDefaultI18n;

  @Prop()
  public overrideI18n!: IHomepageHomeServeExpertOverrideI18n;

  @Prop({ type: String, required: true })
  public image1!: string;

  @Prop({ type: String, required: true })
  public image2!: string;

  @Prop({ type: String, required: true })
  public image3!: string;

  @Prop({ type: String, required: true })
  public image4!: string;

  created() {
    this.defaultI18n = {
      title: this.$t('components_plugin.homepage.homeserve_expert.title').toString(),
      block_surprise: {
        title: this.$t('components_plugin.homepage.homeserve_expert.block_surprise.title').toString(),
        desc: this.$t('components_plugin.homepage.homeserve_expert.block_surprise.desc').toString(),
      },
      block_trust: {
        title: this.$t('components_plugin.homepage.homeserve_expert.block_trust.title').toString(),
        desc: this.$t('components_plugin.homepage.homeserve_expert.block_trust.desc').toString(),
      },
      block_proximity: {
        title: this.$t('components_plugin.homepage.homeserve_expert.block_proximity.title').toString(),
        desc: this.$t('components_plugin.homepage.homeserve_expert.block_proximity.desc').toString(),
      },
      block_quick: {
        title: this.$t('components_plugin.homepage.homeserve_expert.block_quick.title').toString(),
        desc: this.$t('components_plugin.homepage.homeserve_expert.block_quick.desc').toString(),
      },
      more_detail: this.$t('components_plugin.homepage.homeserve_expert.more_detail').toString(),
    };
  }
}
